import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import logo from 'assets/img/illustrations/sponsor.png';

const LogoSponsor = ({ at = 'auth', width = 80, className, textClass, ...rest }) => {
  return (
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-4 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={logo} alt="Logo" width={width} />
      </div>
  );
};

LogoSponsor.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

export default LogoSponsor;
